import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class GameiomRecoveryState extends State {
    public onEnter(): void {
        gameWrapper.bonusGameRecovering();
        gameWrapper.setBusy();

        this.setFooterMessage();
        this.complete();
    }

    protected setFooterMessage() {
        const footer = Components.get(FooterComponent);
        const totalStake = Services.get(SlotBetService).getTotalStake()

        if (gameState.getCurrentGame().inFreespins()) {
            footer.showFreespinStart();
        } else {
            footer.showSpinStart(totalStake);
        }
    }
}
